"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _default = exports.default = {
  'dialog-tool': function dialogTool(el, binding) {
    var _arguments = arguments;
    var ts = Array.isArray(binding.value) ? binding.value : [binding.value];
    ts.forEach(function (t) {
      try {
        var _require;
        (_require = require("./".concat(t, ".js"))).default.apply(_require, (0, _toConsumableArray2.default)(_arguments));
      } catch (e) {
        console.warn(e);
      }
    });
  }
};